import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import { useEffect, useMemo } from 'react';
import { IMediumAttributes } from 'shared/interfaces/IMedium';
import { IProjectAttributes } from 'shared/interfaces/IProject';
import { opportunitiesServices } from 'shared/services/opportunitiesServices';
import { useContextSelector } from 'use-context-selector';
import { useProjectItemDataParser } from '../useProjectItemDataParser';

const { getProjectInfo } = opportunitiesServices();
export const useProjectDetailsParser = (
  projectId: string,
  isPublic?: boolean,
  passedProjectData?: IProjectAttributes,
) => {
  const { data: project, isLoading: projectLoading } = getProjectInfo(projectId, isPublic);
  const projectData = useMemo(() => {
    if (passedProjectData) return passedProjectData;
    if (projectLoading) {
      return;
    } else {
      return project ? project?.data.public_projects_on_notice_board : undefined;
    }
  }, [project, projectLoading]);

  const {
    companyName,
    projectName,
    union,
    dates,
    location,
    roles,
    rate,
    release,
    type,
    casting_roles,
    unmatchedRoles,
    companyLogo,
    opportunities_aggregates,
  } =
    isPublic && projectData
      ? useProjectItemDataParser(projectData)
      : passedProjectData
        ? useProjectItemDataParser(passedProjectData)
        : {
            companyName: '-',
            projectName: '-',
            union: '-',
            dates: '-',
            location: '-',
            roles: '-',
            rate: '-',
            release: '-',
            type: '-',
            casting_roles: [],
            unmatchedRoles: 0,
            companyLogo: null,
            opportunities_aggregates: {
              total_casting_roles_on_notice_board_count: 0,
              filtered_casting_roles_on_notice_board_count: 0,
            },
          };

  // const {
  //   conflicts: conflict,
  //   usage,
  //   additional_details,
  //   medium_attachments,
  // } = projectData !== undefined
  //   ? projectData
  //   : { conflicts: [], usage: '', additional_details: '', medium_attachments: [] };

  const conflicts = (projectData && projectData?.conflicts?.join(', ')) || '-';
  const usageRun = projectData?.usage || '-';
  const additionalDetails = projectData?.additional_details || '-';
  const referenceMedia = projectData?.medium_attachments;
  const { total_casting_roles_on_notice_board_count } = opportunities_aggregates || {
    total_casting_roles_on_notice_board_count: 0,
  };
  return {
    projectLoading,
    conflicts,
    usageRun,
    additionalDetails,
    referenceMedia,
    companyName,
    projectName,
    union,
    dates,
    location,
    roles,
    rate,
    release,
    type,
    casting_roles,
    unmatchedRoles,
    companyLogo,
    total_casting_roles_on_notice_board_count,
  };
};
